import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  standalone: false,
  selector: "dua-checkbox",
  templateUrl: "./checkbox.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./checkbox.component.scss"],
})
export class CheckboxComponent implements OnInit {
  private static idCounter = 0;
  readonly checkboxId: string;

  @Input() checked: boolean = true;
  @Input() disabled!: boolean;
  @Input() label: string = "";
  @Input() image: string = "";
  @Output() checkedChange: EventEmitter<boolean> = new EventEmitter();

  constructor() {
    this.checkboxId = `dua-checkbox-${++CheckboxComponent.idCounter}`;
  }

  ngOnInit(): void {}

  onChecked(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.checked = checked;
    this.checkedChange.emit(checked);
  }
}
